export function revisionCheck(revision) {
  return {
    type: 'REVISION_CHECK',
    payload: {
      revision: revision,
		},
	}
};
